module.exports = __webpack_public_path__ + "static/media/tarot-card-9.4a245e51.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/checkastronow/assets/images/tarotcards/tarot-card-9.jpg
// module id = 1555
// module chunks = 0